module.exports = __webpack_public_path__ + "img/ryota_hanabusa.e8d21140.jpg";